import { render } from "./generate_quote.html?vue&type=template&id=7127a61a&external"
import script from "./generate_quote.js?vue&type=script&lang=js&external"
export * from "./generate_quote.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__